import { LIVE_DURATION } from './constants';

export default function(duration) {
  if (duration === Infinity) {
    return LIVE_DURATION;
  } else {
    // https://kollective.atlassian.net/browse/DEV-37183
    // The backend system depends on millisecond based reporting. Players, including the video element in
    // HTML report seconds. So we multiply by 1000.
    // See https://www.w3schools.com/tags/av_prop_duration.asp for video duration.
    return duration * 1000;
  }
}
